<template>
  <div class="navigation" @scroll="onScroll" :class="theme">
    <div class="tabs-wrapper">
      <div class="tabs" :class="{padding:hasPadding}">
        <div v-for="(tab, index) in tabs" :key="'navg'+index" class="tab" :class="{active:currentIndex===index, theme}" :style="{width:tabWidth+'%'}" @click="onClickTab(tab,index)">
          <slot :name="'tab'+index">
            {{tab}}
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navigation',
  data () {
    return {
      tabIndex: 0
    }
  },
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    onScroll: {
      type: Function,
      default: () => { }
    },
    value: {
      type: Number,
      default: 0
    },
    noTransition: {
      type: Boolean,
      default: false
    },
    beforeClickTab: {
      type: Function,
      default: () => true
    },
    hasSlider: {
      type: Boolean,
      default: true
    },
    maxTab: {
      type: Number,
      default: 4
    },
    defaultTabWidth: {
      type: [String, Number],
      default: 0
    },
    hasPadding: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String
    }
  },
  computed: {
    sliderWidth () {
      if (this.defaultTabWidth === 'auto') {
        return
      }
      if (this.defaultTabWidth) return this.defaultTabWidth
      if (this.tabs.length > this.maxTab) {
        return 100 / (this.maxTab + 0.5)
      } else {
        return 100 / this.tabs.length
      }
    },
    sliderLeft () {
      return this.sliderWidth * this.currentIndex
    },
    tabWidth () {
      return this.sliderWidth
    },
    currentIndex: {
      set (value) {
        this.tabIndex = value
        this.$emit('input', value)
      },
      get () {
        return this.value || this.tabIndex
      }
    }
  },
  watch: {
    tabs (newVal, oldVal) {
      if (newVal.length && !oldVal.length) {
        this.$nextTick(() => (this.$el.scrollLeft = this.sliderLeft / 100 * document.body.clientWidth))
      }
    }
  },
  methods: {
    onClickTab (tab, index) {
      if (this.currentIndex === index) return
      if (!this.beforeClickTab()) return
      this.currentIndex = index
    }
  }
}
</script>

<style lang="stylus" scoped>
.navigation {
  // max-width: 100%;
  // width: 100%;
  // min-width: 100%;
  white-space: nowrap;
  color: default-text-color;
  font-size: .15rem;
  background: white;
  border-top: 1px solid #EDEFF3;
  overflow-scroll();
  overflow-y: hidden;
  padding: 0 .045rem;
}

.navigation.dark {
  background: #1a1e2e;
  border-bottom: #12141f;
  color: helper-color;
}

.tabs-wrapper {
  position: relative;
}

.tabs {
  width: 100%;
  padding: 0;
}

.padding {
  padding: 0 .18rem;
}

.tab {
  display: inline-block;
  position: relative;
  text-align: center;
  vertical-align: top;
}

.slider {
  position: absolute;
  top: 0;
  left: 0;
  height: 0.455rem;
  border-bottom: 1px solid primary-color;
  transform: translate3d(0,0,0);
  transition: left .4s;
}

.active {
  color: #007AFF;
}
.active:after {
  content: '';
  display: block;
  width: .42rem;
  height: .02rem
  background-color: #007AFF;
  transform: translate(0, -.02rem);
  margin: 0 auto;
}

.dark
  .active {
    color: #ff8080
  }

.no-transition {
  transition: none;
}
</style>